import { axiosHandler, axiosConfig } from '@/api/common_helpers.js';
import { MEMBER_REGISTRATION_URL, IS_UI_ONLY_MODE } from '@/main.js';

export const registerEmail = async (emailAddress, trialType, miscUrlParams) => {
  try {
    const postData = {
      action: 'registerEmail',
      userId: emailAddress,
      trialType,
      ...miscUrlParams
    };
    // console.log("registerEmail", postData)
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_REGISTRATION_URL, postData)
      return { isSuccessful: true, statusMessage: "" }
    }
    const response = await axiosHandler(MEMBER_REGISTRATION_URL, postData, axiosConfig());
    // console.log("response data", response.data)
    const { statusCode, statusMessage } = response.data
    return { isSuccessful: statusCode === 0, statusMessage };
  } catch (error) {
    console.error('registerEmail', error);
    throw new Error(error);
  }
};

export const verifyEmail = async (userId, token, trialType) => {
  try {
    const postData = {
      action: 'verifyEmail',
      userId,
      token,
      trialType
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_REGISTRATION_URL, postData)
      return true
    }
    const response = await axiosHandler(MEMBER_REGISTRATION_URL, postData, axiosConfig());
    const { statusCode } = response.data
    return statusCode === 0;
  } catch (error) {
    console.error('verifyEmail', error);
    throw new Error(error);
  }
};

export const createAccount = async ({ userId,
  nickname, password, phoneNumber, couponCode, trialType }) => {
  try {
    const postData = {
      action: 'createAccount',
      userId,
      nickname,
      password,
      telephone: phoneNumber,
      trialCode: couponCode,
      trialType,
      clientType: 'web'
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_REGISTRATION_URL, postData)
      return true
    }
    // console.log("createAccount", postData)
    const response = await axiosHandler(MEMBER_REGISTRATION_URL, postData, axiosConfig());
    // console.log("response data", response.data)
    const { statusCode } = response.data
    return statusCode === 0;
  } catch (error) {
    console.error('createAccount', error);
    throw new Error(error);
  }
};

export const startTrial = async (userId, payPeriod, campaignId) => {
  try {
    const postData = {
      action: "startTrial",
      userId,
      payPeriod,
      campaignId
    };
    console.log("startTrial try", postData)
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_REGISTRATION_URL, postData)
      return {}
    }
    const response = await axiosHandler(MEMBER_REGISTRATION_URL, postData, axiosConfig());
    const { data } = response
    // console.log("startTrial data", data);
    return data
  } catch (error) {
    console.error('startTrial', error);
    // throw new Error(error);
  }
};

export const forceDaily = async (userId) => {
  try {
    // console.log("forceDaily try")
    const postData = {
      action: "forceDaily",
      userId
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_REGISTRATION_URL, postData)
      return true
    }
    const response = await axiosHandler(MEMBER_REGISTRATION_URL, postData, axiosConfig());
    const { data } = response
    // console.log("forceDaily data", data);
    return data
  } catch (error) {
    console.error('forceDaily', error);
    // throw new Error(error);
  }
};
